import { Api } from 'utils';

class ChatService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/chats/',params),
		view: async (params?: any) => Api.createResponse('admin/chats/view',params),
	}

}

export default ChatService;